module.exports = __webpack_public_path__ + "static/iot.f0f42b3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/iot.jpg
// module id = 181
// module chunks = 118514840243029 146230036245944